import { render, staticRenderFns } from "./FazendaModule.vue?vue&type=template&id=52acc964"
import script from "./FazendaModule.vue?vue&type=script&lang=js"
export * from "./FazendaModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports